// Ensure a browser-friendly `process` exists for any dynamically loaded chunks
// that may reference it (some third-party bundles expect it on `window`).
if (typeof window !== "undefined" && typeof window.process === "undefined") {
  window.process = { env: {} };
}

import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import * as serviceWorker from "./serviceWorker";

// ngrok's free-tier interstitial blocks XHR requests without this header
// (and it strips CORS headers when it does). Only attach it for requests
// going to an *.ngrok-free.dev / *.ngrok.io tunnel (local dev testing) —
// this never fires against the real production API.

// axios.interceptors.request.use((config) => {
//   if (config.url && /ngrok/.test(config.url)) {
//     config.headers["ngrok-skip-browser-warning"] = "true";
//   }
//   return config;
// });

import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

// import { store } from "./store"
import { Provider } from "react-redux";
import reducers from "./reducers";
import Routes from "./routes";
import { loginUserSuccess, loginFromAndroidBridge } from "./actions/auth";

import "./assets/scss/index.scss";
import CustomScripts from "./CustomScripts";
import MetaScripts from "./MetaScripts";

// Keep application dispatches independent from browser extensions that may
// inject a bundle expecting Node's unavailable `process` global.
const composeEnhancers = compose;

export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk))
);

axios.interceptors.request.use((config) => {
  const method = String(config.method || "get").toLowerCase();
  if (method === "get" && !config.timeout) config.timeout = 60000;
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error?.config || {};
    const method = String(config.method || "get").toLowerCase();
    if (
      method === "get" &&
      !axios.isCancel(error) &&
      (!error?.response || error?.code === "ECONNABORTED") &&
      !config.__fellafeedsResumeRetry
    ) {
      config.__fellafeedsResumeRetry = true;
      return new Promise((resolve) => window.setTimeout(resolve, 500)).then(() =>
        axios(config)
      );
    }
    return Promise.reject(error);
  }
);

const androidBridge = typeof window !== "undefined" ? window.AndroidBridge : null;
const hasAndroidAuthBridge =
  androidBridge &&
  typeof androidBridge.getAuthToken === "function" &&
  typeof androidBridge.getUser === "function";
const environment = process.env.NODE_ENV;
const production = environment === "production";

if (hasAndroidAuthBridge) {
  // Native methods are synchronous. Read them before mounting Routes so its
  // first authenticated requests use the same token as the Android app.
  let token = null;
  let user = null;
  try {
    const bridgeToken = androidBridge.getAuthToken();
    if (typeof bridgeToken === "string" && /^[0-9a-f]{40}$/i.test(bridgeToken)) {
      token = bridgeToken;
    }
    const bridgeUser = androidBridge.getUser();
    if (typeof bridgeUser === "string" && bridgeUser) {
      user = JSON.parse(bridgeUser);
    }
  } catch (error) {
    // A missing or malformed native session should not prevent the login page
    // from rendering. loadUser will fetch the full profile for a valid token.
  }

  localStorage.removeItem("Token");
  localStorage.removeItem("user");
  if (token) {
    store.dispatch(loginFromAndroidBridge(token, user));
  }
} else {
  const token = localStorage.getItem("Token");
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    // The token can still be checked by /rest-auth/user/ after startup.
  }
  if (token) {
    store.dispatch(loginUserSuccess(token, user));
  }
}

const rootElement = document.getElementById("root");
const isTicketPortal = window.location.pathname.startsWith("/ticket-portal/");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <Provider store={store}>
      {production && !isTicketPortal && <CustomScripts />}
      {!isTicketPortal && <MetaScripts />}
      <Routes />
    </Provider>,
    rootElement
  );
} else {
  ReactDOM.hydrate(
    <Provider store={store}>
      {production && !isTicketPortal && <CustomScripts />}
      {!isTicketPortal && <MetaScripts />}
      <Routes />
    </Provider>,
    rootElement
  );
}

// ReactDOM.render(
//     <Provider store={store}>
//         <Routes />
//     </Provider>,
//     document.getElementById('root')
// )

serviceWorker.unregister();
